import { render, staticRenderFns } from "./TaskElaboration.vue?vue&type=template&id=75050e14&scoped=true&"
import script from "./TaskElaboration.vue?vue&type=script&lang=ts&"
export * from "./TaskElaboration.vue?vue&type=script&lang=ts&"
import style0 from "./TaskElaboration.vue?vue&type=style&index=0&id=75050e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75050e14",
  null
  
)

export default component.exports